import { useNavigate } from "react-router-dom";
import { ALGORITHM_LIST } from "../data/algorithmsData";
import * as Icons from "lucide-react";
import { ArrowUpRight, Network } from "lucide-react";

const Icon = ({ name, className, color }) => {
  const C = Icons[name] || Icons.Circle;
  return <C className={className} style={{ color }} strokeWidth={1.5} />;
};

export default function AlgorithmsHub() {
  const nav = useNavigate();

  return (
    <div className="space-y-8 animate-fadeUp" data-testid="algorithms-hub">
      <header className="border-l-2 border-[#CCFF00] pl-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// HUB ALGORITHMES</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">Algorithmes Réseaux</h1>
        <p className="text-zinc-400 mt-2 max-w-2xl">Choisis une plateforme pour ouvrir sa stratégie complète : 4 phases du push algorithmique, actions du jour, KPIs, erreurs killers.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {ALGORITHM_LIST.map(algo => (
          <button
            key={algo.slug}
            onClick={() => nav(`/algorithmes/${algo.slug}`)}
            data-testid={`algo-card-${algo.slug}`}
            className="group text-left border border-[#1E1E24] bg-[#0A0A0C] hover:border-[#CCFF00]/40 rounded-sm p-6 transition-all hover:bg-[#0C0C0E]"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="w-11 h-11 rounded-sm flex items-center justify-center border" style={{ background: `${algo.color}15`, borderColor: `${algo.color}40` }}>
                <Icon name={algo.icon} className="w-5 h-5" color={algo.color} />
              </div>
              <ArrowUpRight className="w-4 h-4 text-zinc-600 group-hover:text-[#CCFF00] transition-colors" />
            </div>
            <h3 className="font-display text-xl font-semibold text-white mb-2">{algo.name}</h3>
            <p className="text-sm text-zinc-400 mb-4 leading-relaxed">{algo.tagline}</p>
            <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-wider text-zinc-500 pt-3 border-t border-[#1E1E24]">
              <Network className="w-3 h-3" />
              <span>{algo.phases.length} phases</span>
              <span className="ml-auto" style={{ color: algo.color }}>OPEN →</span>
            </div>
          </button>
        ))}
      </div>

      <div className="border border-[#CCFF00]/30 bg-[#CCFF00]/[0.03] rounded-sm p-5">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[#CCFF00] mb-2">// MÉTHODOLOGIE</div>
        <p className="text-zinc-200 leading-relaxed">
          Chaque algorithme se décompose en <span className="text-[#CCFF00]">paliers</span> (Cold → Engagement → Fidélisation → Scaling). Comprendre ces paliers = savoir <span className="text-[#CCFF00] font-medium">exactement quoi faire</span> à chaque étape pour passer au suivant.
        </p>
      </div>
    </div>
  );
}
